import './pages/Home/less/antMotionStyle.less';

export default function bootstrap() {
  
}
